<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Translations – {{ newsPredefinedName }}</h4>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <button class="btn btn-sm btn-primary" type="button" (click)="onClickAddTranslation()">
            <i class="fa fa-plus"></i> Add Translation
          </button>
        </div>
        <table class="table table-responsive-sm table-hover table-outline mb-0">
          <thead class="thead-light">
            <tr>
              <th>#</th>
              <th>Language</th>
              <th>Title</th>
              <th>Summary</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @if (translations.length === 0) {
              <tr>
                <td colspan="5" class="text-center text-muted">No translations found.</td>
              </tr>
            } @else {
              @for (translation of translations; track translation.languageId; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ getLanguageIso(translation.languageId) }}</td>
                  <td>{{ translation.title }}</td>
                  <td class="text-truncate" style="max-width: 200px;">{{ translation.summary }}</td>
                  <td>
                    <button class="btn btn-sm btn-warning me-1" type="button" (click)="onClickEditTranslation(translation)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                    <span class="text-muted mx-1">|</span>
                    <button class="btn btn-sm btn-danger" type="button" (click)="onClickDeleteTranslation(translation)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.hide()">Close</button>
      </div>
    </div>
  </div>
</div>

<app-news-predefined-translation-add-modal #translationAddModal></app-news-predefined-translation-add-modal>
<app-news-predefined-translation-edit-modal #translationEditModal></app-news-predefined-translation-edit-modal>
